import { Component, HostListener, Input, OnInit } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CashConfirmDialogComponent } from '../../ticket-office/cash-confirm-dialog.component';

@Component({
  selector: 'app-payment-type-dialog',
  standalone: false,
  templateUrl: './payment-type-dialog.component.html',
  styleUrls: ['./payment-type-dialog.component.scss'],
})
export class PaymentTypeDialogComponent implements OnInit {
  @Input() price!: number;
  @Input() paymentTypeAmount!: any;
  @Input() saveLabel = 'cardExtension.save';
  @Input() confirmOnSave = false;
  @Input() submitOnEnter = false;
  @Input() hiddenPaymentTypeIds: number[] = [];

  amountError = false;
  oldPaymentTypeAmount: any;
  private confirmOpen = false;

  constructor(public activeModal: NgbActiveModal, private modalService: NgbModal) {}

  ngOnInit(): void {
    this.paymentTypeAmount = (this.paymentTypeAmount || []).filter(
      (pm: any) => !this.hiddenPaymentTypeIds.includes(pm.paymentTypeId)
    );
    this.oldPaymentTypeAmount = JSON.parse(JSON.stringify(this.paymentTypeAmount));
    this.onChangeAmount();
  }

  onChangeAmount(): void {
    let sum = 0;
    this.paymentTypeAmount.forEach((element: any) => {
      if (element.paymentTypeId !== 1) sum += element.amount;
    });
    if (this.price - sum < 0) {
      this.paymentTypeAmount[0].amount = 0;
      this.amountError = true;
    } else {
      this.paymentTypeAmount[0].amount = (this.price - sum).toFixed(2);
      this.amountError = false;
    }
  }

  onTextClick($event: any): void {
    $event.target.select();
  }

  @HostListener('document:keydown.enter', ['$event'])
  onEnter(event: KeyboardEvent): void {
    if (!this.submitOnEnter || this.confirmOpen || this.amountError) return;
    event.preventDefault();
    this.save();
  }

  save(): void {
    if (this.amountError || this.confirmOpen) return;
    if (!this.confirmOnSave) {
      this.activeModal.close(this.paymentTypeAmount);
      return;
    }
    this.confirmOpen = true;
    const confirmRef = this.modalService.open(CashConfirmDialogComponent, {
      backdrop: 'static',
      centered: true,
    });
    confirmRef.result.then(
      (confirmed) => {
        this.confirmOpen = false;
        if (confirmed === true) this.activeModal.close(this.paymentTypeAmount);
      },
      () => {
        this.confirmOpen = false;
      }
    );
  }

  close(): void {
    this.paymentTypeAmount = JSON.parse(JSON.stringify(this.oldPaymentTypeAmount));
    this.activeModal.close(undefined);
  }
}
